import React from "react";
import "./Splash.css";
import LA from "../assets/images/logo.png";

function Splash() {
  return (
    <div className="splash">
      <img src={LA} alt="" />
      <h1>
        LEO <span>ANTONY</span>
      </h1>
    </div>
  );
}

export default Splash;

{
  /* <svg
  id="svg"
  width="860"
  height="116"
  viewBox="0 0 860 116"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask
    id="path-1-outside-1"
    maskUnits="userSpaceOnUse"
    x="0.882812"
    y="0.21875"
    width="859"
    height="116"
  >
    <rect
      fill="white"
      x="0.882812"
      y="0.21875"
      width="859"
      height="116"
    />
    <path d="M19.4531 97.9609H67.9688V109H5.88281V6.625H19.4531V97.9609Z" />
    <path d="M141.234 61.6797H96.8672V97.9609H148.406V109H83.3672V6.625H147.703V17.7344H96.8672V50.6406H141.234V61.6797Z" />
    <path d="M243.961 61.1172C243.961 71.1484 242.273 79.9141 238.898 87.4141C235.523 94.8672 230.742 100.562 224.555 104.5C218.367 108.438 211.148 110.406 202.898 110.406C194.836 110.406 187.688 108.438 181.453 104.5C175.219 100.516 170.367 94.8672 166.898 87.5547C163.477 80.1953 161.719 71.6875 161.625 62.0312V54.6484C161.625 44.8047 163.336 36.1094 166.758 28.5625C170.18 21.0156 175.008 15.25 181.242 11.2656C187.523 7.23438 194.695 5.21875 202.758 5.21875C210.961 5.21875 218.18 7.21094 224.414 11.1953C230.695 15.1328 235.523 20.875 238.898 28.4219C242.273 35.9219 243.961 44.6641 243.961 54.6484V61.1172ZM230.531 54.5078C230.531 42.3672 228.094 33.0625 223.219 26.5938C218.344 20.0781 211.523 16.8203 202.758 16.8203C194.227 16.8203 187.5 20.0781 182.578 26.5938C177.703 33.0625 175.195 42.0625 175.055 53.5938V61.1172C175.055 72.8828 177.516 82.1406 182.438 88.8906C187.406 95.5938 194.227 98.9453 202.898 98.9453C211.617 98.9453 218.367 95.7812 223.148 89.4531C227.93 83.0781 230.391 73.9609 230.531 62.1016V54.5078Z" />
    <path d="M356.461 82.2812H313.57L303.938 109H290.016L329.109 6.625H340.922L380.086 109H366.234L356.461 82.2812ZM317.648 71.1719H352.453L335.016 23.2891L317.648 71.1719Z" />
    <path d="M472.547 109H458.977L407.438 30.1094V109H393.867V6.625H407.438L459.117 85.8672V6.625H472.547V109Z" />
    <path d="M565.148 17.7344H532.242V109H518.812V17.7344H485.977V6.625H565.148V17.7344Z" />
    <path d="M657.117 61.1172C657.117 71.1484 655.43 79.9141 652.055 87.4141C648.68 94.8672 643.898 100.562 637.711 104.5C631.523 108.438 624.305 110.406 616.055 110.406C607.992 110.406 600.844 108.438 594.609 104.5C588.375 100.516 583.523 94.8672 580.055 87.5547C576.633 80.1953 574.875 71.6875 574.781 62.0312V54.6484C574.781 44.8047 576.492 36.1094 579.914 28.5625C583.336 21.0156 588.164 15.25 594.398 11.2656C600.68 7.23438 607.852 5.21875 615.914 5.21875C624.117 5.21875 631.336 7.21094 637.57 11.1953C643.852 15.1328 648.68 20.875 652.055 28.4219C655.43 35.9219 657.117 44.6641 657.117 54.6484V61.1172ZM643.688 54.5078C643.688 42.3672 641.25 33.0625 636.375 26.5938C631.5 20.0781 624.68 16.8203 615.914 16.8203C607.383 16.8203 600.656 20.0781 595.734 26.5938C590.859 33.0625 588.352 42.0625 588.211 53.5938V61.1172C588.211 72.8828 590.672 82.1406 595.594 88.8906C600.562 95.5938 607.383 98.9453 616.055 98.9453C624.773 98.9453 631.523 95.7812 636.305 89.4531C641.086 83.0781 643.547 73.9609 643.688 62.1016V54.5078Z" />
    <path d="M756.047 109H742.477L690.938 30.1094V109H677.367V6.625H690.938L742.617 85.8672V6.625H756.047V109Z" />
    <path d="M809.273 58.0234L835.992 6.625H851.32L816.023 70.8203V109H802.523V70.8203L767.227 6.625H782.695L809.273 58.0234Z" />
  </mask>
  <path
    d="M19.4531 97.9609H67.9688V109H5.88281V6.625H19.4531V97.9609Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M141.234 61.6797H96.8672V97.9609H148.406V109H83.3672V6.625H147.703V17.7344H96.8672V50.6406H141.234V61.6797Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M243.961 61.1172C243.961 71.1484 242.273 79.9141 238.898 87.4141C235.523 94.8672 230.742 100.562 224.555 104.5C218.367 108.438 211.148 110.406 202.898 110.406C194.836 110.406 187.688 108.438 181.453 104.5C175.219 100.516 170.367 94.8672 166.898 87.5547C163.477 80.1953 161.719 71.6875 161.625 62.0312V54.6484C161.625 44.8047 163.336 36.1094 166.758 28.5625C170.18 21.0156 175.008 15.25 181.242 11.2656C187.523 7.23438 194.695 5.21875 202.758 5.21875C210.961 5.21875 218.18 7.21094 224.414 11.1953C230.695 15.1328 235.523 20.875 238.898 28.4219C242.273 35.9219 243.961 44.6641 243.961 54.6484V61.1172ZM230.531 54.5078C230.531 42.3672 228.094 33.0625 223.219 26.5938C218.344 20.0781 211.523 16.8203 202.758 16.8203C194.227 16.8203 187.5 20.0781 182.578 26.5938C177.703 33.0625 175.195 42.0625 175.055 53.5938V61.1172C175.055 72.8828 177.516 82.1406 182.438 88.8906C187.406 95.5938 194.227 98.9453 202.898 98.9453C211.617 98.9453 218.367 95.7812 223.148 89.4531C227.93 83.0781 230.391 73.9609 230.531 62.1016V54.5078Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M356.461 82.2812H313.57L303.938 109H290.016L329.109 6.625H340.922L380.086 109H366.234L356.461 82.2812ZM317.648 71.1719H352.453L335.016 23.2891L317.648 71.1719Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M472.547 109H458.977L407.438 30.1094V109H393.867V6.625H407.438L459.117 85.8672V6.625H472.547V109Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M565.148 17.7344H532.242V109H518.812V17.7344H485.977V6.625H565.148V17.7344Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M657.117 61.1172C657.117 71.1484 655.43 79.9141 652.055 87.4141C648.68 94.8672 643.898 100.562 637.711 104.5C631.523 108.438 624.305 110.406 616.055 110.406C607.992 110.406 600.844 108.438 594.609 104.5C588.375 100.516 583.523 94.8672 580.055 87.5547C576.633 80.1953 574.875 71.6875 574.781 62.0312V54.6484C574.781 44.8047 576.492 36.1094 579.914 28.5625C583.336 21.0156 588.164 15.25 594.398 11.2656C600.68 7.23438 607.852 5.21875 615.914 5.21875C624.117 5.21875 631.336 7.21094 637.57 11.1953C643.852 15.1328 648.68 20.875 652.055 28.4219C655.43 35.9219 657.117 44.6641 657.117 54.6484V61.1172ZM643.688 54.5078C643.688 42.3672 641.25 33.0625 636.375 26.5938C631.5 20.0781 624.68 16.8203 615.914 16.8203C607.383 16.8203 600.656 20.0781 595.734 26.5938C590.859 33.0625 588.352 42.0625 588.211 53.5938V61.1172C588.211 72.8828 590.672 82.1406 595.594 88.8906C600.562 95.5938 607.383 98.9453 616.055 98.9453C624.773 98.9453 631.523 95.7812 636.305 89.4531C641.086 83.0781 643.547 73.9609 643.688 62.1016V54.5078Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M756.047 109H742.477L690.938 30.1094V109H677.367V6.625H690.938L742.617 85.8672V6.625H756.047V109Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
  <path
    d="M809.273 58.0234L835.992 6.625H851.32L816.023 70.8203V109H802.523V70.8203L767.227 6.625H782.695L809.273 58.0234Z"
    stroke="#FFFEFE"
    stroke-width="10"
    mask="url(#path-1-outside-1)"
  />
</svg> */
}
